export default class GetConvocatoriaById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idConvocatoria) {
    try {
      const result = await this.#repository.getConvocatoriaById(idConvocatoria)
      return result
    } catch (error) {
      console.error('Error al obtener la convocatoria:', error)
      throw error
    }
  }
}
